import {pdf, DocumentProps} from '@react-pdf/renderer';
import {Share} from '@capacitor/share';
import {Filesystem, Directory} from '@capacitor/filesystem';
import PlatformService from 'src/services/PlatformService';

async function blobToBase64(blob: Blob): Promise<string> {
  const arrayBuffer = await blob.arrayBuffer();
  const bytes = new Uint8Array(arrayBuffer);
  let binary = '';

  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return btoa(binary);
}

export async function generatePdfBlob(
  pdfDocument: React.ReactElement<DocumentProps>
): Promise<Blob> {
  const pdfInstance = pdf(pdfDocument);
  return pdfInstance.toBlob();
}

export function downloadPdfForWeb(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function sharePdfForAnyPlatform(
  pdfDocument: React.ReactElement<DocumentProps>,
  filename: string,
  title = 'Resume',
  text = 'My Raise.me Resume'
): Promise<void> {
  const pdfBlob = await generatePdfBlob(pdfDocument);

  if (!PlatformService.isNativeApp()) {
    downloadPdfForWeb(pdfBlob, filename);
    return;
  }

  const base64Data = await blobToBase64(pdfBlob);
  const savedFile = await Filesystem.writeFile({
    path: filename,
    data: base64Data,
    directory: Directory.Cache,
  });

  await Share.share({
    title,
    text,
    url: savedFile.uri,
    dialogTitle: 'Share Resume',
  });
}
